import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  PrivateNumberBuyRequestStatus,
  SmsCp,
  UpdatePrivateNumberBuyRequestStatusCommand,
} from 'src/app/core/api/models';
import { PrivateNumberBuyRequestService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { DialogService } from 'src/app/core/services/dialog.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-update-status-private-number-price',
    templateUrl: './update-status-private-number-price.component.html',
    styleUrls: ['./update-status-private-number-price.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class UpdateStatusPrivateNumberPriceComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  formPageConfig: FormPageConfig<any> = {};
  model: UpdatePrivateNumberBuyRequestStatusCommand = {};

  privateNumberPriceSmsCp: SmsCp;
  privateNumberBuyRequestStatus: PrivateNumberBuyRequestStatus;

  isShowEnabledSmsSenderAgentId: boolean = false;
  isShowDisabledSmsSenderAgentId: boolean = false;
  isShowRejectionDescription: boolean = false;

  get PrivateNumberBuyRequestStatus() {
    return PrivateNumberBuyRequestStatus;
  }

  //#endregion

  constructor(
    protected currentService: PrivateNumberBuyRequestService,
    public dialogService: DialogService,
    public http: HttpClient,
    private dialogRef: MatDialogRef<UpdateStatusPrivateNumberPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.vocabs = data.pageVocabs;
    this.pageVocabs = this.formPageConfig.vocabs;
    this.model.privateNumberBuyRequestId = data.id;
    this.formPageConfig.title =
      this.pageVocabs + 'updateStatusPrivateNumberPriceTitle';
    this.privateNumberPriceSmsCp = data.smsCp;
    this.privateNumberBuyRequestStatus = data.status;
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      privateNumberBuyRequestStatus: new FormControl('', Validators.required),
      rejectionDescription: new FormControl(''),
      smsSenderAgentId: new FormControl(''),
      isService: new FormControl(false),
    });
  }

  onChangePrivateNumberBuyRequestStatus() {
    try {
      this.isShowRejectionDescription = false;
      this.isShowEnabledSmsSenderAgentId = false;
      this.isShowDisabledSmsSenderAgentId = false;

      this.form.get('smsSenderAgentId').clearValidators();
      this.form.get('rejectionDescription').clearValidators();

      switch (this.model.privateNumberBuyRequestStatus) {
        case PrivateNumberBuyRequestStatus.CertainAssignment:
          this.isShowEnabledSmsSenderAgentId = true;
          this.form
            .get('smsSenderAgentId')
            .setValidators([Validators.required]);

          break;

        case PrivateNumberBuyRequestStatus.Rejected:
        case PrivateNumberBuyRequestStatus.WaitingDocumentsUpload:
          this.form
            .get('rejectionDescription')
            .setValidators([Validators.required]);
          this.isShowRejectionDescription = true;
          break;

        default:
          break;
      }

      this.form.get('smsSenderAgentId').updateValueAndValidity();
      this.form.get('rejectionDescription').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  //#region api

  privateNumberBuyRequestUpdateApi(
    model: UpdatePrivateNumberBuyRequestStatusCommand
  ) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .privateNumberBuyRequestUpdateStatus({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit(): void {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      if (this.model.isService == undefined || this.model.isService == null)
        this.model.isService = false;

      this.privateNumberBuyRequestUpdateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
